var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.715 4.064h-3.25V.814l3.25 3.25zm-3.25.813h3.25v7.719a1.22 1.22 0 01-1.218 1.219H2.184a1.203 1.203 0 01-1.219-1.22V2.034c0-.66.534-1.219 1.22-1.219h4.468v3.25c0 .457.355.813.812.813zM7.44 8.305L6.45 9.32V6.705c0-.33-.28-.61-.61-.61-.355 0-.609.28-.609.61V9.32L4.215 8.305a.6.6 0 00-.406-.178.613.613 0 00-.432.178c-.253.254-.253.634 0 .863l2.032 2.031c.228.254.61.254.838 0l2.03-2.031c.255-.229.255-.61 0-.863a.598.598 0 00-.837 0z",
    fill: "#2358F8"
  })));
}
export default SvgDownloadFile;